import {Famigliare} from './famigliare';

export class NucleoFamigliare {
  famigliareList: Famigliare[];
}
